import { apiCall } from '../../services/apiUtil';

export const invitationsApi = {
  getMyInvitations: () => apiCall('/invitations/mine'),
  acceptInvitation: (id) => apiCall(`/invitations/${id}/accept`, { method: 'PATCH' }),
  declineInvitation: (id) => apiCall(`/invitations/${id}/decline`, { method: 'PATCH' }),
};
